import React from 'react'
import { BsCheck2Circle } from 'react-icons/bs'
import { useNavigate } from 'react-router-dom'

export const VerifyEmail = () => {
    const navigate = useNavigate()

    return (
        <div className='text-lg'>
            <div className="flex justify-center">
                <BsCheck2Circle className='text-[10rem] text-success'></BsCheck2Circle>
            </div>
            <div className="text-font-primary my-12">
                <p className='text-2xl pb-8'>¡NECESITAS VALIDAR TU CORREO ELECTRONICO!</p>
                Recibirás un código de verificación a tu correo <br/> electrónico para validar la autenticidad de tu cuenta.
            </div>
            <div className="">
                <button className='w-[50%] uppercase rounded-[20rem] bg-primary text-xl rounded px-8 py-4 text-white'
                    onClick={() => navigate('/')}>
                    Ir a Inicio
                </button>
            </div>
        </div>
    )
}
